/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AidModelResultsResponseDto,
  CalculateAidModelResultsParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';
import { customAxiosResponse } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns the composed actual + estimated Aid Results bands for the aid model.
 * @summary Get results
 */
export const getAidModelResults = (
  oktaUserId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelResultsResponseDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/results`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAidModelResultsQueryKey = (
  oktaUserId: string,
  modelId: number
) => {
  return [`/api/${oktaUserId}/aid-models/${modelId}/results`] as const;
};

export const getGetAidModelResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAidModelResults>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAidModelResultsQueryKey(oktaUserId, modelId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAidModelResults>>
  > = ({ signal }) =>
    getAidModelResults(oktaUserId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAidModelResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAidModelResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAidModelResults>>
>;
export type GetAidModelResultsQueryError = ErrorType<unknown>;

export function useGetAidModelResults<
  TData = Awaited<ReturnType<typeof getAidModelResults>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelResults>>,
          TError,
          Awaited<ReturnType<typeof getAidModelResults>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelResults<
  TData = Awaited<ReturnType<typeof getAidModelResults>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelResults>>,
          TError,
          Awaited<ReturnType<typeof getAidModelResults>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelResults<
  TData = Awaited<ReturnType<typeof getAidModelResults>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get results
 */

export function useGetAidModelResults<
  TData = Awaited<ReturnType<typeof getAidModelResults>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAidModelResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAidModelResultsQueryOptions(
    oktaUserId,
    modelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns the composed actual + estimated Aid Results bands for the aid model. When recalculate=false (default), the actual band is loaded from cache if present; otherwise it is computed and persisted. When recalculate=true, the cache is overwritten. The estimated band is always computed fresh.
 * @summary Get results
 */
export const calculateAidModelResults = (
  oktaUserId: string,
  modelId: number,
  params?: CalculateAidModelResultsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelResultsResponseDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/results`,
      method: 'POST',
      params,
      signal,
    },
    options
  );
};

export const getCalculateAidModelResultsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateAidModelResults>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      params?: CalculateAidModelResultsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculateAidModelResults>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    params?: CalculateAidModelResultsParams;
  },
  TContext
> => {
  const mutationKey = ['calculateAidModelResults'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculateAidModelResults>>,
    {
      oktaUserId: string;
      modelId: number;
      params?: CalculateAidModelResultsParams;
    }
  > = (props) => {
    const { oktaUserId, modelId, params } = props ?? {};

    return calculateAidModelResults(
      oktaUserId,
      modelId,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculateAidModelResultsMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculateAidModelResults>>
>;

export type CalculateAidModelResultsMutationError = ErrorType<unknown>;

/**
 * @summary Get results
 */
export const useCalculateAidModelResults = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculateAidModelResults>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        params?: CalculateAidModelResultsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof calculateAidModelResults>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    params?: CalculateAidModelResultsParams;
  },
  TContext
> => {
  return useMutation(
    getCalculateAidModelResultsMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />Returns the aid model student dataset with raw warehouse columns and per-student New-Projected calculation traces for current-year and next-year tracks.
 * @summary Download results dataset CSV
 */
export const downloadAidModelResultsDataset = (
  oktaUserId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxiosResponse>,
  signal?: AbortSignal
) => {
  return customAxiosResponse<Blob>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/results/download`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getDownloadAidModelResultsDatasetQueryKey = (
  oktaUserId: string,
  modelId: number
) => {
  return [`/api/${oktaUserId}/aid-models/${modelId}/results/download`] as const;
};

export const getDownloadAidModelResultsDatasetQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAidModelResultsDatasetQueryKey(oktaUserId, modelId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAidModelResultsDataset>>
  > = ({ signal }) =>
    downloadAidModelResultsDataset(oktaUserId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadAidModelResultsDatasetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAidModelResultsDataset>>
>;
export type DownloadAidModelResultsDatasetQueryError = ErrorType<unknown>;

export function useDownloadAidModelResultsDataset<
  TData = Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
          TError,
          Awaited<ReturnType<typeof downloadAidModelResultsDataset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAidModelResultsDataset<
  TData = Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
          TError,
          Awaited<ReturnType<typeof downloadAidModelResultsDataset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAidModelResultsDataset<
  TData = Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download results dataset CSV
 */

export function useDownloadAidModelResultsDataset<
  TData = Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAidModelResultsDataset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadAidModelResultsDatasetQueryOptions(
    oktaUserId,
    modelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
